import angular from 'angular';
import {
  loaderService,
  pmSharedModelService,
  pmDataService,
  ssDialogService,
} from 'app/services';
import {
  richTextEditor,
  alerts,
  actionIcon
} from 'app/components/global';

import subsectionsPanel from './subsections-panel.directive';
import subsectionsPanelController from './subsections-panel.controller';
import template from './edit-section-dialog.html';
import controller from './edit-section-dialog.controller';
import tokensTabPanel from './tokensTabPanel';
import requiredMessagesTpl from './required.messages.html';
import materialChangeDialog from '../../../dialog.materialChangeDialog';

class dialogService {
  getOptions($event, { permissions, policyDocumentId, section }) {
    return {
      controller,
      controllerAs: 'editSectionDialogVM',
      locals: {
        permissions,
        policyDocumentId,
        section,
      },
      bindToController: true,
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.pm.editSectionDialog', [
  actionIcon,
  alerts,
  loaderService,
  pmSharedModelService,
  pmDataService,
  richTextEditor,
  ssDialogService,
  tokensTabPanel,
  materialChangeDialog,
])
  .directive('pmSubsectionsPanel', subsectionsPanel)
  .controller('SubsectionsPanelController', subsectionsPanelController)
  .service('editSectionDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('required.messages.html', requiredMessagesTpl);
  })
  .name;
